import { IOrganizationalUnitContextData } from 'interfaces/commons/IContext';
import { createContext } from 'react';

export const OrganizationalUnitContext = createContext<IOrganizationalUnitContextData>({} as IOrganizationalUnitContextData);
